/**
 * Pure locale resolution, kept free of require.context so tests can exercise it
 * with an injected list (jest has no require.context).
 */

// Case-insensitive lookup that answers with the CANONICAL file name - the
// resolved value is used as a file key and gets persisted, so it must be the
// spelling the directory actually uses (pt_BR, not pt_br).
function findCanonical(name, supported) {
  const lower = name.toLowerCase();

  return supported.find((locale) => locale.toLowerCase() === lower) || null;
}

// Maps one raw language tag onto the locales the app ships: an exact file match
// first ('pt-BR' / 'pt_br' / 'PT-BR' -> pt_BR), the base language second
// ('fr-FR' -> fr). Case-insensitive throughout - stale localStorage and
// non-canonical user agents spell tags every way. Returns null when nothing
// matches - never an unvalidated string.
function matchSupportedLocale(candidate, supported) {
  if (typeof candidate !== 'string' || !candidate) return null;

  const exact = candidate.replace('-', '_');

  return (
    findCanonical(exact, supported) ||
    findCanonical(exact.split('_')[0], supported)
  );
}

// The first candidate that resolves wins - callers pass their preference order,
// e.g. [saved locale, navigator language]. Null when none of them ships.
export function resolveSupportedLocale(candidates, supported) {
  for (const candidate of candidates) {
    const match = matchSupportedLocale(candidate, supported);

    if (match) return match;
  }

  return null;
}
